import React from 'react';
import { Navigate } from 'react-router-dom';

/** Legacy route — routing rules now live under RIS Configuration. */
export default function Configuration() {
  return (
    <Navigate
      to="/ris-configuration?tab=routing"
      replace
    />
  );
}
